import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { useComponentProperties, useFetchedValues } from "../../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { byAttributeName } from "../../utils";

const DependentProperty = () => {

    const selectedComponent = useSelectedComponent();

    const [properties, setProperty] = useComponentProperties();

    const [{ generalProperties: fetchedValues }] = useFetchedValues();

    const [dependentAttributes, setDependentAttributes] = useState([]);

    const { t } = useTranslation("display/components/calendar");

    useEffect(() => {
        if (fetchedValues.attributes && fetchedValues.attributes.length > 0) {
            const dependentAttributes = fetchedValues.attributes
                                    .filter(attribute => !attribute.isSystemAttribute && attribute.attributeType === "String")
                                    .sort(byAttributeName);
            setDependentAttributes(dependentAttributes)
        }
    }, [fetchedValues.attributes])

    const handleDependentPropertyChange = (e) => {
        setProperty("dependentAttribute", e.target.value)
    }

    return (
        <DropDownList
            style={{ width: "200px" }}
            disabled={selectedComponent.hidden}
            onChange={handleDependentPropertyChange}
            value={properties.dependentAttribute}
            textField='attributeName'
            data={dependentAttributes}
            dataItemKey='_id'
        />
    )
}

export default DependentProperty;